/**
 * Generate message id
 * @param {MESSAGE_TYPE} messageType
 * @returns String
 */
export const generateMessageId = (messageType = '') => {
  const messageId =
    new Date().getUTCMilliseconds() * Math.random(999) * 10 ** 15;

  if (!messageType) return messageId.toString();

  return `${messageType}-${messageId}`;
};
